export enum ETipoAmbiente
{
    Administracao = 1,
    Plataforma = 2,
}
